// Base URL of Email_service. Set REACT_APP_API_BASE_URL in .env.development.local to test locally.
export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || "https://tinpan.proteantech.in";
